







































































































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import ModalCrearReasignacion from './ModalCrearReasignacion.vue';
import ModalEditarReasignacion from './ModalEditReasignacion.vue';
import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component, Watch } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { eventBus, actionsEvent } from '@/setup';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import Confirmation from '../../../components/Confirmation.vue';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { utils, writeFileXLSX } from 'xlsx';
import { fetchReasignacionEquipos } from './fetchReasignacionEquipos';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  ICellRendererParams,
  RowNode,
} from 'ag-grid-community';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { LoadingService } from '@/services/loadingService';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';

@Component({
  components: {
    MantenedorGridSinCodigo,
    DatePicker,
    'app-confirmacion': Confirmation,
    FormFieldsContainer,
    ModalCrearReasignacion,
    ModalEditarReasignacion,
  },
})
export default class ReasignacionEquipos extends ComponenteBase {
  usuarioActivo: any;
  vValidate(vValidate: any) {
    throw new Error('Method not implemented.');
  }
  ordesList: any[] = [];
  filtro: string = '';
  filtroNDV: string = '';
  estado: any[] = [
    { estadoid: 'S', estado: 'SOLICITADA' },
    { estadoid: 'V', estado: 'VALIDADA' },
    { estadoid: 'C', estado: 'COMPLETADA' },
    { estadoid: 'A', estado: 'ANULADA' },
  ];
  isNew: boolean = false;
  isEdit: boolean = false;
  isView: boolean = false;
  consulta: any = {
    tecnico: '',
    coordinador: '',
    estado: '',
    courier: '',
    dateStart: moment()
      .subtract(1, 'month')
      .format('YYYY/MM/DD'),
    dateEnd: moment().format('YYYY/MM/DD'),
  };
  funcionalidad: Funcionalidades = Funcionalidades.ReasignacionEquipos;
  isComplete: boolean;
  isValidate: boolean;
  isAnular: boolean;

  exportarExcel() {
    let informacionOrdenada = this.ordesList.map((e: any) => {
      return {
        'Fecha Emisión': moment(e.resigfecha_alta).format('YYYY-MM-DD'),
        'Nota de Venta': e.ndvnumero_destino,
        Rut: e.usuariorut_alta,
        'Razón social': e.nombre,
        Coordinador: e.coorname,
        Técnico: e.tecniconame,
        'Tipo de Equipo': e.tequiponame,
        Serie: e.serienumero,
        SIM: e.simserienumero,
        Estado: e.estado,
        'Usuario Creación': e.usernamecre,
        'Usuario Valida': e.usernameval,
        'Usuario Completa': e.usernamecom,
        'Usuario Anula': e.usernameanu,
      };
    });
    const ws = utils.json_to_sheet(informacionOrdenada);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Reasignación');
    writeFileXLSX(wb, 'Reasignacion de equipos.xlsx');
    this.$snotify.success('Excel exportado con éxito', 3000);
  }

  async getReasignaciones() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReasignacionEquipos(
      {
        dateStart: this.consulta.dateStart ? this.consulta.dateStart : '',
        dateEnd: this.consulta.dateEnd ? this.consulta.dateEnd : '',
        notaventa: this.consulta.notaventa ? this.consulta.notaventa : '',
        tecnico: this.consulta.tecnico ? this.consulta.tecnico : '',
        coordinador: this.consulta.coordinador ? this.consulta.coordinador : '',
        estado: this.consulta.estado ? this.consulta.estado : '',
      },
      'conectaReasignacion/inicio'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  ordenList: any[] = [];
  tecnico: any[] = [];
  coordinador: any[] = [];
  localidad: any[] = [];
  tipoeq: any[] = [];

  async getFiltros() {
    let self = this;
    return fetchReasignacionEquipos({ '': '' }, 'conectaReasignacion/getFilter')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.tecnico = data.data.TECNICO;
          this.coordinador = data.data.COORDINADOR;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      });
  }

  despaAnterior: number;
  valorMax: number;
  codigosList: any[] = [];

  async datoEditado(dato: boolean) {
    if (dato) {
      this.ordesList = await this.getReasignaciones();
      this.gridApi.setRowData(this.ordesList);
    }
  }

  async datoNuevo(dato: any) {
    this.ordesList = await this.getReasignaciones();
    this.gridApi.setRowData(this.ordesList);
    this.getFiltros();
  }

  async handleGridReady(event: GridReadyEvent) {
    this.getUsuario();
    this.ordesList = await this.getReasignaciones();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
    this.getFiltros();
  }

  async filtrar() {
    this.ordesList = [];
    this.gridApi.setRowData(this.ordesList);
    this.consulta = {
      notaventa: this.formFields.notaventa.value,
      tecnico: this.formFields.tecnico.value,
      coordinador: this.formFields.coordinador.value,
      estado: this.formFields.estado.value,
      dateStart: moment(this.formFields.dateStart.value.toString()).format(
        'YYYY/MM/DD'
      ),
      dateEnd: moment(this.formFields.dateEnd.value.toString()).format(
        'YYYY/MM/DD'
      ),
    };
    this.ordesList = await this.getReasignaciones();
    this.gridApi.setRowData(this.ordesList);
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }
  mounted() {}

  async getUsuario() {
    let self = this;
    let user = JSON.parse(localStorage.getItem('user')).id;
    return fetchReasignacionEquipos(
      { userId: user },
      'conectaReasignacion/getUsuario'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.usuarioActivo = data.data.data.LISTA;
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      });
  }

  onSelectionChanged(params: any) {}

  showModalNew = false;
  pasoActivoIndex = 1;
  pasoActivoEditar = 1;

  clearFilters() {
    this.formFields.tecnico.value = '';
    this.formFields.coordinador.value = '';
    this.formFields.notaventa.value = '';
    this.formFields.dateStart.value = moment().subtract(1, 'month');
    this.formFields.dateEnd.value = moment();
    this.formFields.estado.value = '';
    this.filtrar();
  }

  formFields: FormFieldDefMap = {
    tecnico: {
      label: 'Técnico',
      id: 'tecnicoid',
      value: '',
    },
    coordinador: {
      label: 'Coordinador',
      id: 'coorid',
      value: '',
    },
    estado: {
      label: 'Estado',
      id: 'estadoId',
      value: '',
    },
    notaventa: {
      label: 'Nombre Nota de Venta',
      id: 'nombreNota',
      value: '',
    },
    dateStart: {
      label: 'Fecha de Emisión Inicio',
      value: moment().subtract(1, 'month'),
      id: '',
    },
    dateEnd: {
      label: 'Fecha de Emisión Fin',
      value: moment(),
      id: '',
    },
  };

  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: false,
  };

  accionEditar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };

  accionVerDetalle: PermisoAccion = {
    accionCodigo: 4,
    visible: false,
  };

  accionCompletar: PermisoAccion = {
    accionCodigo: 137,
    visible: false,
  };
  accionValidar: PermisoAccion = {
    accionCodigo: 138,
    visible: false,
  };
  accionAnularReasignacion: PermisoAccion = {
    accionCodigo: 139,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionCrear,
    this.accionVerDetalle,
    this.accionEditar,
    this.accionCompletar,
    this.accionAnularReasignacion,
    this.accionValidar,
  ];

  // Globales
  tabModel: string = 'tab-3';
  muestraBarraBotones: boolean = false;
  registrosAsociar: any = [];
  rowsPerPageItems: any = [];
  dialog: Boolean = false;
  search: string = '';
  localeText: any = config.agGridTextos;
  showTabPerfiles: boolean = true;
  showTabRoles: boolean = true;
  loadingService = new LoadingService();
  paramsExportar: any; //Parametros para Exportar
  intervalo: any; //Intervalo para el buscador
  chequearPermisosBtnCrear: boolean = true;
  editedIndex: number = -1;
  nombreModulo: string = '';
  AccionesPerfilesAsociados: number = 0;
  dialogConfirmacionCompletarClose: boolean = false;
  dialogConfirmacionValidarClose: boolean = false;
  dialogConfirmacionAnularClose: boolean = false;
  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  agGridUtil: AgGridUtil;
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  showModalEdit: boolean = false;
  modalEsEdicion: boolean = false;
  modalEsInformar: boolean = false;
  modalEsDetalles: boolean = false;

  dateFormatter(params: any) {
    return moment(params.value).format('YYYY/MM/DD');
  }

  constructor() {
    super();
    actionsEvent.onCompletar(this.handleCompletar);
    actionsEvent.onEditar(this.handleEditar);
    actionsEvent.onVerDetalle(this.handleVerDetalle);
    actionsEvent.onValidar(this.handleValidar);
    actionsEvent.onAnularReasignacion(this.handleAnularReasignacion);
  }
  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Fecha de Emisión',
        field: 'resigfecha_alta',
        resizable: true,
        sortable: true,
        hide: false,
        width: 150,
        lockPinned: true,
        valueFormatter: this.dateFormatter,
      },
      {
        headerName: 'Nota de Venta',
        field: 'ndvnumero_destino',
        resizable: true,
        sortable: true,
        width: 150,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Rut',
        field: 'usuariorut_alta',
        resizable: true,
        sortable: true,
        width: 150,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Razón Social',
        field: 'nombre',
        sortable: true,
        resizable: true,
        width: 200,
        lockPinned: true,
        filter: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Coordinador',
        field: 'coorname',
        width: 200,
        lockPinned: true,
        sortable: true,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Técnico',
        field: 'tecniconame',
        sortable: true,
        resizable: true,
        width: 170,
        lockPinned: true,
        filter: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Tipo de equipo',
        field: 'tipoeqname',
        width: 150,
        lockPinned: true,
        sortable: true,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Serie',
        field: 'serienumero',
        resizable: true,
        width: 150,
        lockPinned: true,
        sortable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'SIM',
        field: 'simserienumero',
        resizable: true,
        width: 130,
        minWidth: 80,
        lockPinned: true,
        sortable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Estado',
        field: 'estado',
        resizable: true,
        width: 130,
        minWidth: 80,
        lockPinned: true,
        sortable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Usuario Creación',
        field: 'usernamecre',
        resizable: true,
        width: 200,
        lockPinned: true,
        sortable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Usuario Valida',
        field: 'usernameval',
        resizable: true,
        width: 200,
        lockPinned: true,
        sortable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Usuario Completa',
        field: 'usernamecom',
        resizable: true,
        width: 200,
        lockPinned: true,
        sortable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Usuario Anula',
        field: 'usernameanu',
        resizable: true,
        width: 200,
        lockPinned: true,
        sortable: true,
        cellStyle: { textAlign: 'left' },
      },
    ],

    pagination: true,
    paginationPageSize: 25, //Solución Paginación
    //cacheBlockSize: 50, //Solución Paginación
    //paginationAutoPageSize: false,
    rowModelType: 'normal',
    //rowModelType: 'serverSide',
    rowSelection: 'single',
    columnTypes: {
      fecha: {
        sortable: true,
        resizable: true,
        filter: false,
      },
    },
    suppressCsvExport: true,
    suppressExcelExport: true,
    onGridReady: this.handleGridReady,
    onModelUpdated: this.onModelUpdated,
    onSelectionChanged: this.onSelectionChanged,

    processCellForClipboard: ({ value }) => {
      return value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value;
    },
    onGridSizeChanged: event => {
      //event.api.sizeColumnsToFit();
    },
  };

  generarActionEvents() {}

  handleEditar(params: ICellRendererParams) {
    if (
      params.data.estado !== 'COMPLETADA' &&
      params.data.estado !== 'ANULADA'
    ) {
      this.showModalEdit = true;
      this.editedItem = params.data.reasignumero;
      this.isEdit = true;
    } else {
      this.$snotify.warning(
        'No se puede editar una Reasignación que ya se encuentre completada o Anulada.',
        { timeout: 3000 }
      );
    }
  }

  handleVerDetalle(params: ICellRendererParams) {
    this.isView = true;
    this.showModalEdit = true;
    this.editedItem = params.data.reasignumero;
  }
  estadoNuevo: any = '';
  usuarioValida: boolean = false;
  usuarioCompleta: boolean = false;
  usuarioAnula: boolean = false;
  handleValidar(params: ICellRendererParams) {
    this.estadoNuevo = '';
    if (
      params.data.estado !== 'COMPLETADA' &&
      params.data.estado !== 'ANULADA' &&
      params.data.estado !== 'VALIDADA' &&
      params.data.estado == 'SOLICITADA'
    ) {
      this.dialogConfirmacionValidarClose = true;
      this.editedItem = params.data.reasignumero;
      this.estadoNuevo = 'V';
      this.usuarioValida = true;
      this.usuarioCompleta = false;
      this.usuarioAnula = false;
    } else {
      this.$snotify.warning(
        'No se puede editar una Reasignación que ya se encuentre en estado Completada,Anulada o que ya se encuentra validada.',
        { timeout: 3000 }
      );
    }
  }

  handleCompletar(params: ICellRendererParams) {
    this.estadoNuevo = '';
    if (
      params.data.estado !== 'COMPLETADA' &&
      params.data.estado !== 'ANULADA' &&
      params.data.estado !== 'SOLICITADA' &&
      params.data.estado == 'VALIDADA'
    ) {
      this.dialogConfirmacionValidarClose = true;
      this.editedItem = params.data.reasignumero;
      this.estadoNuevo = 'C';
      this.usuarioCompleta = true;
      this.usuarioValida = false;
      this.usuarioAnula = false;
    } else {
      this.$snotify.warning(
        'No se puede Completar una Reasignación que ya se encuentre en estado Solicitado,completado o Anulada.',
        { timeout: 3000 }
      );
    }
  }

  handleAnularReasignacion(params: ICellRendererParams) {
    this.estadoNuevo = '';
    if (
      params.data.estado !== 'COMPLETADA' &&
      params.data.estado !== 'ANULADA'
    ) {
      this.dialogConfirmacionValidarClose = true;
      this.editedItem = params.data.reasignumero;
      this.estadoNuevo = 'A';
      this.usuarioValida = false;
      this.usuarioCompleta = false;
      this.usuarioAnula = true;
    } else {
      this.$snotify.warning(
        'No se puede Anular una Reasignación que ya se encuentre en estado completada o Anulada.',
        { timeout: 3000 }
      );
    }
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  created() {}

  async actualizarEstado() {
    let self = this;
    let user = JSON.parse(localStorage.getItem('user')).id;
    return fetchReasignacionEquipos(
      {
        estadoNuevo: this.estadoNuevo,
        reasignumero: this.editedItem,
        userid: user,
        usuarioCompleta: this.usuarioCompleta,
        usuarioAnula: this.usuarioAnula,
        usuarioValida: this.usuarioValida,
      },
      'conectaReasignacion/actualizarEstado'
    )
      .then(async (data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success('Actualización Exitosa', { timeout: 3000 });
          this.ordesList = await this.getReasignaciones();
          this.gridApi.setRowData(this.ordesList);
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      });
  }

  moduloModalCallback(val: boolean) {
    this.showModalNew = val;
    this.showModalEdit = val;
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionValidarClose = false;
    if (val) {
      this.actualizarEstado();
    }
  }
}
